<template>
  <div class="project-show leads-listing">
    <lead-create :id="id"/>
    <empty-state
      v-if="this.emptyState === 'leads'"
      name="leads"
      :heading="emptyStateHeading"
      :subtitle="emptyStateSubtitle"
      :button="true"
    />
    <div v-else>
      <div class="search-container">
        <searchbar :value="query.search" @search="search" :model="model"></searchbar>
        <div :title="$t('ui.filters.hint')" class="filter-trigger icon yule-icon-settings" @click="filterDisplay = !filterDisplay">
        </div>
      </div>
      <transition name="test">
        <leads-filtering v-if="filterDisplay && query.filters" @apply="filterUpdate" @reset="filterReset" :filters="query"></leads-filtering>
      </transition>
      <div class="leads-listing--desktop">
      <leads-listing @sorting="sorting" @itemDelete="itemDelete" :loading="loading" :data="items" :structure="correctedStructure" :params="{project_id: id, global_sorting: true, sort_by: this.query.sort_by, sort_order: this.query.sort_order}" model="project_lead" :has_searched="has_searched"></leads-listing>
      </div>
      <div class="leads-listing--mobile">
        <leads-listing @sorting="sorting" @itemDelete="itemDelete" :loading="loading" :data="items" :structure="structure_mobile" :params="{project_id: id, global_sorting: true, sort_by: this.query.sort_by, sort_order: this.query.sort_order}" model="project_lead" :has_searched="has_searched"></leads-listing>
      </div>
      <pagination v-if="!loading" @goToPage="goToPage" :page="page" :total-pages="total_pages"></pagination>
    </div>
  </div>
</template>
<script>
import Api from '@/api/Lead'
import ProjectApi from '@/api/Project.js'
import {collectionMixin} from '@/components/mixins/Collection'
import ProjectUserAssign from './../ProjectUserAssign'
import Ui from '@/classes/Ui'
import { EventBus } from '@/EventBus.js';
import LeadCreate from '@/components/pages/project/leads/LeadCreate'
import Searchbar from '@/components/layouts/partials/Searchbar.vue'
import LeadsFiltering from '@/components/helpers/Specific/LeadsFiltering.vue'
import LeadsListing from '@/components/helpers/Specific/LeadsListing'
import EmptyState from '@/components/helpers/DataDisplay/EmptyState'

let default_sort_by = "start_date"
let default_sort_order = "DESC"
let default_filters = {sync_status: {value: []}, origin: {value: []}, import_origin: {value: []}, sync_disabled: {value: []} , start_date: {start: null, end: null, type: 'date'}, tags: {value: [], type: 'tag'}}

export default {
  components: {
    ProjectUserAssign,
    LeadsFiltering,
    Searchbar,
    LeadCreate,
    LeadsListing,
    EmptyState
  },
  mixins: [collectionMixin],
  props: {
    id: {
      required: true
    }
  },
  data(){
    return {
      model: "project_leads",
      api: new Api(),
      crmPresence: false,
      collectionData: {},
      level: 2,
      lead_mask: {},
      query: { project_id: this.id },
      download_message: '',
      loading: false,
      filterDisplay: false,
      projectReady: false,
      enableLeadReview: false,
      has_searched: false,
      correctedStructure: {},
      projectNavigation: [
        { name: "project_leads", action: "project_leads.list", credential: "project_leads.list"},
        { name: "project_statistics", action: "project_leads.statistics", credential: "projects.statistics", access: "allowed_statistics" },
        { name: "project_edit", action: "project.edit", credential: "projects.update" },
        { name: "project_assignments_edit", action: "project_assignments.edit", credential: "projects.update" }
      ],
      structure: [
        { name: 'id', sortable: true, credentials: 'root'},
        { name: 'classification', type: "classification", class: "no-padding" },
        { name: 'firstname', alias: 'name', type: 'lead_name', sortable: true },
        { name: 'company', type: 'company', sortable: true },
        { name: 'progress_indicator_lead_mask', type: 'progress' },
        { name: 'updated_at', type: 'date', time: true, sortable: true },
        { name: 'action', type: 'crud_action_folded', credentials: 'admin', exclude: ['show', 'duplicate'] }
      ],
      structure_talents: [
        { name: 'id', sortable: true, credentials: 'root'},
        { name: 'classification', type: "classification", class: "no-padding" },
        { name: 'firstname', alias: 'name', type: 'lead_name', sortable: true },
        { name: 'progress_indicator_lead_mask', type: 'progress' },
        { name: 'updated_at', type: 'date', time: true, sortable: true },
        { name: 'action', type: 'crud_action_folded', credentials: 'admin', exclude: ['show', 'duplicate'] }
      ],
      structure_mobile: [
        { name: 'classification', type: "classification", class: "no-padding" },
        { name: 'name', type: 'lead_name',  sortable: true},
        { name: 'company', type: 'company', sortable: true },
        { name: 'progress_indicator_lead_mask', type: 'progress' },
        { name: 'action', type: 'crud_action_folded', credentials: 'admin', exclude: ['show', 'duplicate'] }
      ],
      status_structure: { name: 'status', type: 'status', sortable: true },
      crm_sync_structure: { name: 'sync_status', type: 'crm_status', class: "txtcenter", sortable: true },
      collectionMixinConfig: {
        storeResetPage: 'RESET_CURRENT_PAGE_LEADS',
        routerName: 'project_leads',
        emptyState: 'leads',
        default_filters: default_filters,
        default_sort_by: default_sort_by,
        default_sort_order: default_sort_order
      }
    }
  },
  computed: {
    storeQuery () {
      return _.cloneDeep(this.$store.state.filters)
    },
    emptyState() {
      return this.$store.getters.getEmptyState
    },
    currentPlanIsTalents() {
      return this.$store.getters.getCurrentPlanIsTalent
    },
    emptyStateHeading() {
      return this.$t("ui.empty_state.leads.title")
    },
    emptyStateSubtitle() {
      return this.$t("ui.empty_state.leads.subtitle")
    }
  },
  mounted(){
    if (this.page != Ui.getCurrentPageLeads()) {
      this.goToPage(Ui.getCurrentPageLeads())
    }

    this.setDefaultUiButtons()
    Ui.setSecondaryHeaderTabs(this.projectNavigation)

    EventBus.$off('xls_export')
    EventBus.$on('xls_export', payload=>{
      if(payload=="project_leads.export"){
        this.exportXls()
      }
    })

    this.setProjectInStore()
  },
  created(){
     //  In case we generate a query, we create it before to be able to retrieve it in collection and display the specific list.
    this.initQuery()
  },
  beforeDestroy() {
    this.$store.commit('SET_SECONDARY_HEADER_TABS', [])
  },
  methods:{
    setCorrectStructure() {

      // reset correctedStructure
      this.correctedStructure = {}

      if (this.currentPlanIsTalents) {
        this.correctedStructure = this.structure_talents
      } else {

        // add crm sync structure if crm is present
        if(this.projectReady && this.crmPresence) {
          let structure_length = this.structure.length
          this.structure.splice(structure_length - 1, 0, this.crm_sync_structure)
        }

        // add status to the structure if lead filter is enabled in the project settings
        if(this.projectReady && this.enableLeadReview) {
          let structure_length = this.structure.length
          this.structure.splice(structure_length - 1, 0, this.status_structure)
        }

        this.correctedStructure = this.structure
      }

      return this.correctedStructure

    },
    setDefaultUiButtons() {
      Ui.setHeaderButtons([
        { name: "project_leads_export", event_name: 'xls_export', action: "project_leads.export", classes: "btn-tertiary", icon: "", debounce: 30000 },
        { name: "project_lead", action: "project_leads.add_popup", classes: "btn-primary", icon: "" }
      ])
    },
    setLeadsEmptyStateButtons() {
      Ui.setHeaderButtons([
        { name: "project_lead", action: "project_leads.add_popup", classes: "btn-primary", icon: "" }
      ])
    },
    exportXls(){
      let api = new ProjectApi()
      api.send_xls(this.id, null, 'en').then((item) => {
        this.download_message = this.$t('ui.pages.project-download-data-suceed')
        this.$store.commit('SET_NOTIFICATION', {
          'title': 'ui.pages.project-download-data-suceed',
          'type': 'success'
        })
      }).catch((error) => {
      })
    },
    async setProjectInStore() {
      let project = await new ProjectApi().show(this.id)
      this.$store.commit('SET_CURRENT_PROJECT', project)
      Ui.setSubtitle({link: {name: "projects"}})
      Ui.setTitle({label: project.name})

      if(project){
        this.projectReady = true
        this.enableLeadReview = this.$store.getters.getCurrentProject.enable_lead_review
        this.crmPresence = this.$store.getters.getOrganizationConfig('crm_presence')
        this.setCorrectStructure()
      }
    }
  },
  watch: {
    emptyState() {
      if(this.emptyState === null) {
        this.setDefaultUiButtons()
      } else if (this.emptyState === 'leads') {
        this.setLeadsEmptyStateButtons()
      }
    }
  }
}
</script>
<style lang="scss" scoped>

.wrapper {
  height: 70vh;
}
</style>
<style lang="scss">

.project_lead-firstname {
  a{
    font-weight: $font-medium;
    text-decoration: none;
    display: block;
    font-size: 1em;
    transition: all .15s ease-out;
    &:hover{
      color: $sensual-dark;
    }
    &:active{
      color: $sensual-darker;
    }
    }
}


.project_lead-company {
  font-size: .8em;
  font-weight: $font-medium;
  color: $ink;
}
.leads-listing--desktop{
  @media(max-width: 699px) {
    display: none;
  }
}
.leads-listing--mobile{
  @media(min-width: 700px) {
    display: none;
}
}
.search-container{
  display: flex;
  margin-bottom: 16px;
  align-items: center;
  justify-content: space-between;
  .searchbar{
    margin-bottom: 1em;
    width: 100%;
  }
  .filter-trigger{
    user-select: none;
    cursor: pointer;
  }
  .yule-icon-settings {
    font-size: 1em;
    &:before {
    color: $paper-dark;
    }
  }
}

.project_lead{
  .project_lead-classification{
    width: 0;
    text-align: center;
  }
  td{
    vertical-align: middle;
  }
  .project_lead-name{
    padding-left: 1em;
    .value-show--firstname,
    .value-show--lastname{
      font-size: 0.875em;
      font-weight: $font-medium;
    }
    a{
      font-weight: $font-medium;
      text-decoration: none;
      display: block;
      &:active{
        color: $sensual-dark;
      }
      &:hover{
        color: $sensual-darker;
      }
    }


  }
  .table td{
    vertical-align: middle;
  }
}
.project-show{
  .actions{
    text-align: right;
    .download-message{
      font-style: italic;
      color: $color-success;
    }
    .btn{
      margin-right: 0;
    }
  }
}
.classification-wrapper{
  width: 15px;
}
.value-classification{
  border-radius: 50%;
  width: 18px;
  height: 18px;
  position: absolute;
  margin-top: -10px;
  &.cold{
    background-color: $lead-cold;
    &::before{
      content: '';
      position: absolute;
      background-color: $lead-cold-dark;
      border-radius: 50%;
      width: 6px;
      height: 6px;
      top: 6px;
      left: 6px;
    }
  }
  &.warm{
    background-color: $lead-warm;
    &::before{
      content: '';
      position: absolute;
      background-color: $yellow-dark;
      border-radius: 50%;
      width: 6px;
      height: 6px;
      top: 6px;
      left: 6px;
    }
  }
  &.hot{
    background-color: $lead-hot;
    &::before{
      content: '';
      position: absolute;
      background-color: $red-dark;
      border-radius: 50%;
      width: 6px;
      height: 6px;
      top: 6px;
      left: 6px;
    }
  }
  &.unclassified{
    background-color: $lead-unclassified;
    &::before{
      content: '';
      position: absolute;
      background-color: $ink;
      border-radius: 50%;
      width: 6px;
      height: 6px;
      top: 6px;
      left: 6px;
    }
  }
}
.project_lead-progress_indicator_lead_mask{
  min-width: 150px;
}
.project_lead-sync_status{
  text-align: center;
}

.project_lead-progress_indicator_businesskit{
  min-width: 125px;
}

.leads-listing {

.modal-box {
    position: relative;
    max-height: 90%;
}
.modal-box--title {
    margin-top: 0;
    font-size: 2em;
    font-weight: 400;
    margin-bottom: 1em;

}

  .modal-box--content{
    padding: 0;
    max-width: 100%;
  }


}
.leads-listing--mobile {
  .main-content {
    padding: .5em;
  }
  .project_lead-name {
    font-size: 1.2em;
  }
  .value-progress {
    .progress-percentage {
      font-size: 12px;
      color: $ink-lighter;
      text-align: center;
      padding: 0;
      width: auto;
    }
}
  .progress-bar {
    width: 50px;
    flex-grow: auto;
  }
  .value-progress {
    flex-direction: column-reverse;
  }
  .project_lead-progress_indicator_lead_mask{
    min-width: 0;
  }
}
.project_lead-updated_at{
  .value-show{
    font-size: 12px;
    color: $ink-lighter;
    font-weight: $font-regular;
    }
}
.project_lead-status{
  .value-show{
    font-size: 12px;
    color: $ink-lighter;
    font-weight: $font-regular;
    }
}
.project_lead-id{
  .value-show{
    font-size: 12px;
    color: $ink-lighter;
    font-weight: $font-regular;
    }
}

@media(max-width: 575px) {
  .search-container {
      flex-direction: column;
    }
    .filter-trigger {
      align-self: flex-start;
  }
  .project_lead .project_lead-name .value-show--firstname,
  .project_lead .project_lead-name .value-show--lastname  {
    font-size: 14px;
  }
}
</style>



// WEBPACK FOOTER //
// Leads.vue?c8ae1684